// ============================================================================
// VYVA Onboarding Portal - Auth Layout
// ============================================================================

import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store';
import vyvaLogo from '@/assets/logo-purple.png';

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuthStore();

  // Redirect authenticated users to dashboard
  if (!isLoading && isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 overflow-auto">
      {/* Decorative Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#7A2CC7]/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#3653FF]/10 rounded-full blur-3xl" />
      </div>

      {/* Main Content - Centered */}
      <div className="relative z-10 w-full max-w-md px-4 flex flex-col items-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img src={vyvaLogo} alt="VYVA" className="h-12 w-40 object-contain" />
        </div>

        {/* Auth Card */}
        <div className="w-full bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
          <Outlet />
        </div>

        {/* Footer */}
        <p className="text-center text-sm text-muted-foreground mt-6">
          © {new Date().getFullYear()} VYVA Health. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default AuthLayout;

